
import React, { useEffect } from 'react';
import { User } from "lucide-react";
import OrderSummary from './form-sections/OrderSummary';
import PaymentFormWrapper from './form-wrappers/PaymentFormWrapper';
import FormHeader from './form-sections/FormHeader';

interface ClientDataFormProps {
  selectedOffer: 'standard' | 'premium' | 'exclusive';
  offerPrice: number;
  onSubmitSuccess: () => void;
  numberOfRooms: number;
  roomAreas: number[];
  installationType: 'home' | 'company';
}

const ClientDataForm: React.FC<ClientDataFormProps> = ({ 
  selectedOffer, 
  offerPrice,
  onSubmitSuccess,
  numberOfRooms,
  roomAreas,
  installationType
}) => {
  console.log('ClientDataForm - values:', { numberOfRooms, roomAreas });
  
  useEffect(() => {
    console.log('ClientDataForm useEffect - values:', { numberOfRooms, roomAreas });
  }, [numberOfRooms, roomAreas]);
  
  return (
    <div className="w-full max-w-4xl mx-auto opacity-0 animate-fadeIn">
      <div className="glass-card p-6 md:p-8">
        <div className="space-y-6">
          <FormHeader />
          
          <OrderSummary selectedOffer={selectedOffer} offerPrice={offerPrice} />
          
          <PaymentFormWrapper
            selectedOffer={selectedOffer}
            offerPrice={offerPrice}
            onSubmitSuccess={onSubmitSuccess}
            numberOfRooms={numberOfRooms}
            roomAreas={roomAreas}
            installationType={installationType}
          />
        </div>
      </div>
    </div>
  );
};

export default ClientDataForm;
